import React from "react";
import { Link, FormattedMessage } from "gatsby-plugin-intl";
import classNames from "classnames";
import navItems from "components/Header/navItems";
import { useMobileNavContext } from "context/mobileNavContext";
// import Search from "components/Header/Search";

import "./mobile-menu.scss";

const MobileMenu = () => {
  const mobileNavContext = useMobileNavContext();

  return (
    <div
      style={{ top: 105 }}
      className={classNames(
        "mobile-menu fixed w-full bg-white left-0 py-2 lg:hidden shadow-sm",
        {
          "mobile-menu--visible": mobileNavContext.open,
          "mobile-menu--invisible": !mobileNavContext.open,
        }
      )}
    >
      <div className="flex flex-col max-w-95p mx-auto">
        <ul className="flex flex-col container">
          {navItems.map(({ i18nLabel, path }) => (
            <li key={i18nLabel} className="text-md py-3">
              <Link
                onClick={mobileNavContext.toggle}
                className="text-black hover:text-gray-700"
                to={path}
              >
                <FormattedMessage id={`navigation.${i18nLabel}`} />
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {/* )} */}
    </div>
  );
};

export default MobileMenu;
